<script>
export default {
  props: {
    email: {
      type: String,
      default: ''
    },
    invitationLoading: {
      type: Boolean,
      default: false
    }
  }
}
</script>
<template>
  <div>
    <v-card-text class="pb-0">
      <v-row>
        <v-col>
          <v-alert border="top" type="warning" dense>
            <span
              v-html="$t('component.profile.administrationManagement.user.exists', { Email: email })"
            />
          </v-alert>
        </v-col>
      </v-row>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-btn
        id="em_close_button"
        color="secondary"
        class="white--text px-8 py-2"
        @click="$emit('cancel')"
      ><span>{{ $t('button.cancel') }}</span></v-btn>
      <v-spacer></v-spacer>
      <v-btn
        id="em_invite_button"
        color="primary"
        class="white--text px-8 py-2"
        :loading="invitationLoading"
        @click="$emit('confirmed')"
      ><span>{{ $t('button.confirm') }}</span></v-btn>
    </v-card-actions>
  </div>
</template>
